import React from 'react';
import classNames from 'classnames/bind';
import styles from './SMSIndicator.scss';


type Props = {
  smsCount: number,
};
const cx = classNames.bind(styles);
const circleLen = 151;

const SMSIndicator = ({ smsCount }: Props) =>
  <div className={styles.root}>
    <div className={cx({ circle: true, danger: !smsCount })}>
      <div className={styles.circleNum}>{smsCount}</div>
      <div className={styles.circleText}>sms</div>

      <svg viewBox="0 0 50 50" className={styles.circleBack}>
        <path
          d="M49,25c0,13.254-10.745,24-24,24 C11.746,49,1,38.254,1,25S11.746,1,25,1C38.255,1,49,11.746,49,25z"
        />
      </svg>
      <svg viewBox="0 0 50 50" className={styles.circleFront}>
        <path
          strokeDasharray={`${circleLen} ${circleLen}`}
          strokeDashoffset={circleLen}
          d="M49,25c0,13.254-10.745,24-24,24 C11.746,49,1,38.254,1,25S11.746,1,25,1C38.255,1,49,11.746,49,25z"
        >
          <animate
            attributeName="stroke-dashoffset"
            from={circleLen}
            to={smsCount ? 0 : circleLen}
            dur="0.5s"
            repeatCount="0"
            fill="freeze"
          />
        </path>
      </svg>
    </div>
  </div>;

export default SMSIndicator;
